import React, { useEffect, useRef } from 'react'

import { useRightPanel } from 'hooks/useRightPanel'

import PhatDropdown from 'components/formElements/PhatDropdown'
import ManaCurves from 'components/deckPage/charts/ManaCurves'
import ColorProductionVsGeneration from 'components/deckPage/charts/ColorProductionVsGeneration'
import Probability from 'components/deckPage/RightPanel/Probability'
import PhatButton from 'components/formElements/PhatButton'
import Icon from 'components/elements/Icon'
import QuantityTables from 'components/deckPage/charts/QuantityTables'
import LegacyStats from 'components/deckPage/RightPanel/LegacyStats'

import { basicKeybindSkips } from 'components/deckPage/modals/KeybindsOverlay'

import styles from './rightPanel.module.scss'

const RightPanelV2 = () => {
  const keylistener = useRef<(e: KeyboardEvent) => void>(() => null)

  const [rightPanelStatus, setRightPanelStatus] = useRightPanel()

  useEffect(() => {
    window.removeEventListener('keydown', keylistener.current)

    if (!rightPanelStatus.open) {
      document.body.classList.remove('no-scrolling')

      return
    }

    if (!rightPanelStatus.locked) document.body.classList.add('no-scrolling')
    else document.body.classList.remove('no-scrolling')

    keylistener.current = (e: KeyboardEvent) => {
      if (basicKeybindSkips(e)) return
      if (e.key === 'Escape' && !rightPanelStatus.locked) {
        e.preventDefault()

        setRightPanelStatus({ ...rightPanelStatus, open: false })
      }
    }

    window.addEventListener('keydown', keylistener.current)

    return () => window.removeEventListener('keydown', keylistener.current)
  }, [rightPanelStatus])

  return (
    <>
      {rightPanelStatus.open && !rightPanelStatus.locked && (
        <div onClick={() => setRightPanelStatus({ ...rightPanelStatus, open: false })} className={styles.dimmer} />
      )}

      <div
        className={`
          ${rightPanelStatus.locked ? styles.lockedContainer : styles.fixedContainer} 
          ${rightPanelStatus.open && !rightPanelStatus.locked ? styles.open : ''}
      `}>
        <div className={styles.content}>
          <div className={styles.controls}>
            <PhatDropdown
              value={rightPanelStatus.type}
              className={styles.viewDropdownContainer}
              triggerWrapperClassName={styles.viewDropdown}
              options={[
                {
                  label: 'Condensed view',
                  onClick: () => setRightPanelStatus({ ...rightPanelStatus, type: 'condensed' }),
                  id: 'condensed',
                },
                { type: 'spacer' },
                {
                  label: 'Colors',
                  onClick: () => setRightPanelStatus({ ...rightPanelStatus, type: 'colors' }),
                  id: 'colors',
                },
                {
                  label: 'Mana Curve',
                  onClick: () => setRightPanelStatus({ ...rightPanelStatus, type: 'manaCurve' }),
                  id: 'manaCurve',
                },
                {
                  label: 'Probability',
                  onClick: () => setRightPanelStatus({ ...rightPanelStatus, type: 'probability' }),
                  id: 'probability',
                },
                {
                  label: 'Quantities',
                  onClick: () => setRightPanelStatus({ ...rightPanelStatus, type: 'qunatities' }),
                  id: 'qunatities',
                },
              ]}
            />

            <PhatButton onClick={() => setRightPanelStatus({ ...rightPanelStatus, locked: !rightPanelStatus.locked })}>
              <Icon name="columns" />
              {rightPanelStatus.locked ? 'Unpin' : 'Pin'}
            </PhatButton>
          </div>

          {rightPanelStatus.type === 'colors' && <ColorProductionVsGeneration />}
          {rightPanelStatus.type === 'probability' && <Probability />}
          {rightPanelStatus.type === 'manaCurve' && <ManaCurves />}
          {rightPanelStatus.type === 'qunatities' && <QuantityTables />}
          {rightPanelStatus.type === 'condensed' && <LegacyStats />}
        </div>
      </div>
    </>
  )
}

export default RightPanelV2
